import React from 'react'

const InsightNoteList = ({noteList, selectedNoteId, onNoteSelect, onDeleteButtonClick}) => {
    const handleDeleteClick = (e, id, title) => {
        e.stopPropagation(); // クリックイベントの伝播を防止
        onDeleteButtonClick(id, title);
    };

    return (
        <>
        <ul className="note-list-container">
                    {noteList && noteList.length > 0 ? (
                        noteList.map((note) => (
                            <li 
                                key={note.id} 
                                data-note-id={note.id}
                                onClick={() => onNoteSelect(note.id)}
                                className={`note-list ${selectedNoteId === note.id ? 'selected' : ''}`}
                            >       
                                <a className="a-note-list">
                                    <div className="note-history-container">
                                        <div className="title-item">
                                            <span>{note.title}</span>
                                        </div>
                                        <div className="div-delete-icon" onClick={(e) => handleDeleteClick(e, note.id, note.title)}>✖</div>
                                    </div>
                                </a>
                            </li>
                        ))
                    ) : (
                        <li>ノートがありません</li>
                    )}
                </ul>
        </>
    )
}

export default InsightNoteList